//torus
import * as THREE from 'three';
import Tween from 'root/animator/tween/tween'
import Ease from 'root/animator/tween/easing'
import { getMouseCoords } from 'root/animator/coords/mouse'
import { Lerp } from 'root/animator/tween/easing'
import { dispatchSetChanging } from '../utils'
import { layers } from '../constants';
import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { Vector2, Vector3, Vector4, Float32BufferAttribute} from 'three';

const sqrt2 = Math.sqrt(2);

class Object4 {

    torus
    geometry
    geomDummy
    material

    radius = 1;
    tube = .25;
    tube2 = .5;
    radialSegments = 14;
    tubularSegments = 34;
    latheSegments = 5;

    rotation = [ 1.9, 0, 0 ]

    position = {
      visible: [ 0, 0, -1 ],
      hidden: [ 0, 0, -25 ]
    }

    state = {
      changing: false,
      visible: false,
    }

    currentRotation = {
      x: 0,
      y: 0,
      z: 0
    }

    mouse = {
        x: 0,
        y: 0
    }

    name = "Torus"

    constructor( scene ) {
        this.init(scene)
    }

    init( scene ) {
        this.updateTorusGeometry = this.updateTorusGeometry.bind(this);
        this.geometry = this.NewTorusGeometry(this.radius, this.tube, this.tube2, this.radialSegments, this.tubularSegments, this.latheSegments);
        this.geometry.rotateX(Math.PI * .5);

        this.material = new THREE.MeshStandardMaterial();
        this.material.metalness = .2;
        this.material.roughness = 1;
        this.material.map = new THREE.Texture();
        this.material.uniforms = {
          iTime: { value: 0 },
          iResolution: { value: {
            x: window.innerWidth * window.devicePixelRatio,
            y: window.innerHeight * window.devicePixelRatio
          }}
        };
        this.material.onBeforeCompile = function (shader) {

          Object.assign(shader.uniforms, this.material.uniforms);
          shader.vertexShader = shader.vertexShader.replace('void main() {', `
            uniform float iTime;
            varying float r;
            varying float R;
            void main() {
              R = length(position.xyz);
            r = length(position.xyz - normalize(vec3(position.x, 0, position.z)));
            `);
          shader.fragmentShader = shader.fragmentShader.replace('void main() {', `
            uniform float iTime;
            vec4 mapTexture(vec2 uv) {
              vec2 gridsize = vec2(1., 1.);
              vec2 cellcoord = fract(uv * gridsize);
              vec2 xy = (2. * cellcoord - 1.);
              float f = abs(xy.x * xy.y * .9);
              uv += 0.5 / gridsize;
              cellcoord = fract(vec2(uv.x, uv.y) * gridsize);
              xy = (2. * cellcoord - 1.);
              f += max(abs(xy.x), abs(xy.y));
              f = 1.2 * (1. - pow(f, 2.));
              vec3 col = pow(vec3(clamp(f, 0., 1.)), vec3(1.7));
              return vec4(col, 1.);
            }
            varying float R;
            varying float r;
            
            void main() {`);

          shader.fragmentShader = shader.fragmentShader.replace('#include <map_fragment>', `
            #ifdef USE_MAP
            diffuseColor *= mapTexture(vUv);
          #endif`);

          shader.fragmentShader = shader.fragmentShader.replace('#include <output_fragment>', `
            outgoingLight += .0028 * mapTexture(vUv).xyz * pow(vec3(1.7 / R), 1.8 * vec3(2.5, 5.8, 3.8));
            gl_FragColor = vec4(outgoingLight, diffuseColor.a);
            `);
        }.bind(this);

        this.torus = new THREE.Mesh( this.geometry, this.material);
        this.torus.rotation.x = Math.PI / 2;

        this.torus.castShadow = true;
        this.torus.receiveShadow = true;

        
        const dirLight = new THREE.DirectionalLight(new THREE.Color().setRGB(.08, .8, .6), .8);
        dirLight.position.copy(new Vector3(- .8, 0, .4).sub(new Vector3(0,0,3.)));
        dirLight.castShadow = true;
        dirLight.shadow.mapSize.width = 1024;
        dirLight.shadow.mapSize.height = 1024;
        dirLight.shadow.camera.near = .3;
        dirLight.shadow.camera.far = 5;
        dirLight.shadow.bias = -.0001;
        this.torus.add(dirLight);
        dirLight.layers.set(layers.TORUS_SCENE)

        this.torus.visible = false
        this.torus.name = this.name
        this.torus.layers.set(layers.TORUS_SCENE)
        this.torus.position.set(...this.position.hidden)
        this.torus.rotation.set(...this.rotation)
        scene.add(this.torus)
    }

    resize() {}

    controls() {
      if (this.mouse.x === null || this.mouse.y === null) { return }
      const mouse = { x: 0, y: 0 }
      mouse.x = ( this.mouse.x - window.innerWidth / 2 ) / window.innerWidth
      mouse.y = ( this.mouse.y - window.innerHeight / 2 ) / window.innerHeight
      this.currentRotation.x = Lerp(this.currentRotation.x, mouse.x)
      this.currentRotation.y = Lerp(this.currentRotation.y, mouse.y)
      this.torus.rotation.set(-this.currentRotation.y / 2 - 1.1, -this.currentRotation.x / 2, 0)
    }

    render__moveIn() {
      this.render__move(
          this.position.visible[2],
          () => { this.state.visible = true },
          Ease.OutCubic
      )
  }
  render__moveOut() {
      this.render__move(
        this.position.hidden[2],
        () => { this.state.visible = false },
        Ease.InCubic,
        1500
      )
  }
  render__move(to: any, onComplete = () => {}, ease = Ease.InCubic, duration = 3000 ) {
      this.state.changing = true
      dispatchSetChanging(true, 0)
      Tween.to(
        this.torus.position.z,
        to,
          {
            renderDelay: 10,
              duration: duration,
              ease: ease,
              onChange: function(context) {
                  this.torus.position.z = context.value
              }.bind(this),
              onComplete: function() { 
                  dispatchSetChanging(false)
                  this.state.changing = false 
                  onComplete()
              }.bind(this)
          }
      )
  }

    render({ visible = false }) {
      if ( !this.state.changing ) {
        if ( !visible && this.state.visible ) {
            this.render__moveOut()
        } else
        if ( visible && !this.state.visible ) {
            this.render__moveIn()
        }
    }


      if (this.state.visible || visible) {
        let t = performance.now() / 1000;
        this.material.uniforms[ 'iTime' ].value = t;
        this.updateTorusGeometry(this.torus.geometry, this.geomDummy.clone(), this.radius, this.tube, this.radialSegments, this.tubularSegments, this.tube2, -t*.3);
        this.torus.geometry.attributes.normal.needsUpdate = true;
        this.torus.geometry.attributes.position.needsUpdate = true;
        this.mouse = getMouseCoords().window

        this.torus.visible = true
      } else {
        this.torus.visible = false
      }
    }

    NewLatheGeometry(points, segments = 4) {

      // buffers
    
      const indices = [];
      const vertices = [];
      const uvs = [];
      const initNormals = [];
      const normals = [];
    
      // helper variables
    
      const vertex = new Vector3();
      const uv = new Vector2();
      const normal = new Vector3();
      const curNormal = new Vector3();
      const prevNormal = new Vector3();
      let dx = 0;
      let dy = 0;
    
      // pre-compute normals for initial "meridian"
    
      // special handling for 1st vertex on path
      dx = points[1].x - points[0].x;
      dy = points[1].y - points[0].y;
      normal.x = dy * 1.0;
      normal.y = - dx;
      normal.z = dy * 0.0;
      prevNormal.copy(normal);
      normal.normalize();
      initNormals.push(normal.x, normal.y, normal.z);
    
      for (let j = 1; j < points.length - 1; j++) {
        dx = points[ j + 1 ].x - points[ j ].x;
        dy = points[ j + 1 ].y - points[ j ].y;
    
        normal.x = dy * 1.0;
        normal.y = - dx;
        normal.z = dy * 0.0;
    
        curNormal.copy(normal);
    
        normal.x += prevNormal.x;
        normal.y += prevNormal.y;
        normal.z += prevNormal.z;
    
        normal.normalize();
    
        initNormals.push(normal.x, normal.y, normal.z);
    
        prevNormal.copy(curNormal);
      }
    
      // special handling for last Vertex on path
      initNormals.push(curNormal.x, curNormal.y, curNormal.z);
    
      // generate vertices, uvs and normals
    
      for (let i = 0; i <= segments; i ++) {
    
        let sin, cos;
        switch (i % 4) {
          case 0: cos = sqrt2/2; sin = sqrt2/2; break;
          case 1: cos = -sqrt2/2; sin = sqrt2/2; break;
          case 2: cos = -sqrt2/2; sin = -sqrt2/2; break;
          default: cos = sqrt2/2; sin = -sqrt2/2; break;
        }
    
        for (let j = 0; j < points.length; j++) {
    
          // vertex
    
          vertex.x = points[ j ].x * sin;
          vertex.y = points[ j ].y;
          vertex.z = points[ j ].x * cos;
    
          vertices.push(vertex.x, vertex.y, vertex.z);
    
          // uv
    
          uv.x = vertex.x / sqrt2;
          uv.y = vertex.z / sqrt2;
    
          uvs.push(uv.x, uv.y);
    
          // normal
    
          const x = initNormals[ 3 * j + 0 ] * sin;
          const y = initNormals[ 3 * j + 1 ];
          const z = initNormals[ 3 * j + 0 ] * cos;
    
          normals.push(x, y, z);
    
        }
    
      }
    
      // indices
    
      for (let i = 0; i < segments; i ++) {
    
        for (let j = 0; j < (points.length - 1); j++) {
    
          const base = j + i * points.length;
    
          const a = base;
          const b = base + points.length;
          const c = base + points.length + 1;
          const d = base + 1;
    
          // faces
    
          indices.push(a, b, d);
          indices.push(c, d, b);
    
        }
    
      }
    
      // build geometry
    
      let lathe = new THREE.BufferGeometry();
      lathe.setIndex(indices);
      lathe.setAttribute('position', new Float32BufferAttribute(vertices, 3));
      lathe.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
      lathe.setAttribute('normal', new Float32BufferAttribute(normals, 3));
      return lathe;
    }
    
    NewTorusGeometry(radius, tube, tube2, radialSegments, tubularSegments, latheSegments) {
      let l, points = [];
      for (let i = 0; i < latheSegments; i ++) {
        l = Math.pow(i / (latheSegments - .5), 2);
        points.push(new THREE.Vector2(1. - Math.pow(l, .45), l));
      }
      points.push(new THREE.Vector2(0, l));
      const lathe = this.NewLatheGeometry(points, 4);
      let all = []
      for (let i = 0; i < (radialSegments+1)*(tubularSegments+1); i++) {
        all.push(lathe.clone());
      }
      this.geomDummy = mergeBufferGeometries(all);
      this.geometry = this.geomDummy.clone();
      this.updateTorusGeometry(this.geometry, this.geomDummy.clone(), radius, tube, radialSegments, tubularSegments, tube2, 0);
      return this.geometry;
    }
    
    updateTorusGeometry(geometry, geomDummy, radius, tube, radialSegments, tubularSegments, tube2, time) {
      let t1 = + 1 / tubularSegments * Math.PI;
      let t2 = - 1 / tubularSegments * Math.PI;
      let cost1 = Math.cos(t1);
      let sint1 = Math.sin(t1);
      let cost2 = Math.cos(t2);
      let sint2 = Math.sin(t2);
    
      for (let j = 0; j <= radialSegments; j++) {
    
        const r = j / radialSegments * Math.PI * 2 + time;
        const cosr = Math.cos(r);
        const sinr = Math.sin(r);
    
        let pos = geometry.attributes.position.array;
        let posDummy = geomDummy.attributes.position.array;
        let nrm = geometry.attributes.normal.array;
        let nrmDummy = geomDummy.attributes.normal.array;
    
        for (let i = 0; i <= tubularSegments; i++) {
    
          const t = i / tubularSegments * Math.PI * 2;
          const px = (radius + tube * cosr) * Math.cos(t);
          const py = (radius + tube * cosr) * Math.sin(t);
          const pz = tube * sinr;
          const cr = 2. * tube * Math.sin(Math.PI / radialSegments) / sqrt2;
          const hr = tube - Math.sqrt(tube * tube - cr * cr / 2);
    
          let R, r1, x1, y1, z1, r2, x2, y2, z2, ct1, ct2; 
          
          r1 = r + 1 / radialSegments * Math.PI;
          r2 = r + 1 / radialSegments * Math.PI;
          R = radius + hr * 2 / sqrt2;
          x1 = (R + tube * Math.cos(r1)) * cost1;
          y1 = (R + tube * Math.cos(r1)) * sint1;
          z1 = tube * Math.sin(r1);
          x2 = x1 - (R + tube * Math.cos(r2)) * cost2;
          y2 = y1 - (R + tube * Math.cos(r2)) * sint2;
          z2 = z1 - tube * Math.sin(r2);
          ct1 = Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
    
          r1 = r - 1 / radialSegments * Math.PI;
          r2 = r - 1 / radialSegments * Math.PI;
          x1 = (R + tube * Math.cos(r1)) * cost1;
          y1 = (R + tube * Math.cos(r1)) * sint1;
          z1 = tube * Math.sin(r1);
          x2 = x1 - (R + tube * Math.cos(r2)) * cost2;
          y2 = y1 - (R + tube * Math.cos(r2)) * sint2;
          z2 = z1 - tube * Math.sin(r2);
          ct2 = Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
    
          let sintp = Math.sin(t-Math.PI / 2);
          let costp = Math.cos(t-Math.PI / 2);
    
          let latheCount = (this.latheSegments + 1) * 5;
          let latheStride = latheCount * (j * (tubularSegments + 1) + i)
          for(let k = 0; k < latheCount; k++) {
            let stride = 3*(latheStride + k);
            let x = posDummy[stride+0];
            let y = posDummy[stride+1];
            let z = posDummy[stride+2];
            let ct = (z > 0) ? ct1 : ct2;
    
            // lathe.scale
            pos[stride+0] = x * ct / sqrt2;
            pos[stride+1] = y * tube2 - hr;
            pos[stride+2] = z * cr;
    
            // lathe.rotateX(r);
            x = pos[stride+0];
            y = pos[stride+1];
            z = pos[stride+2];
            let nx = nrmDummy[stride+0];
            let ny = nrmDummy[stride+1];
            let nz = nrmDummy[stride+2];
            pos[stride+1] = y * cosr - z * sinr;
            pos[stride+2] = y * sinr + z * cosr;
            nrm[stride+1] = ny * cosr - nz * sinr;
            nrm[stride+2] = ny * sinr + nz * cosr;
            y = pos[stride+1];
            z = pos[stride+2];
            ny = nrm[stride+1];
            nz = nrm[stride+2];
    
            //lathe.rotateZ(t-Math.PI / 2);
            pos[stride+0] = x * costp - y * sintp;
            pos[stride+1] = x * sintp + y * costp;
            nrm[stride+0] = nx * costp - ny * sintp;
            nrm[stride+1] = nx * sintp + ny * costp;
            x = pos[stride+0];
            y = pos[stride+1];
    
            //lathe.translate(px, py, pz);
            pos[stride+0] = px + x;
            pos[stride+1] = py + y;
            pos[stride+2] = pz + z;
          }
        }
      }
    }
}

export default Object4
